import { CapaQuotationDetailedServiceType } from '@generated/graphql';
import Assets from '../Assets';

export default [
  {
    id: 1,
    name: 'SLA',
    src: Assets.Printing.SLAImage,
    serviceEnum: CapaQuotationDetailedServiceType.Sla,
    url:
      'https://capa.ai/blog/posts/3d-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83'
  },
  {
    id: 2,
    name: 'FDM',
    src: Assets.Printing.FDMImage,
    serviceEnum: CapaQuotationDetailedServiceType.Fdm,
    url:
      'https://capa.ai/blog/posts/3d-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83'
  },
  {
    id: 3,
    name: 'Polyjet',
    src: Assets.Printing.PolyjetImage,
    serviceEnum: CapaQuotationDetailedServiceType.Polyjet,
    url:
      'https://capa.ai/blog/posts/3d-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83'
  },
  {
    id: 4,
    name: 'MJF',
    src: Assets.Printing.MJFImage,
    serviceEnum: CapaQuotationDetailedServiceType.Mjf,
    url:
      'https://capa.ai/blog/posts/3d-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83'
  },
  {
    id: 5,
    name: 'SLS',
    src: Assets.Printing.SLSImage,
    serviceEnum: CapaQuotationDetailedServiceType.Sls,
    url:
      'https://capa.ai/blog/posts/3d-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83'
  },
  {
    id: 6,
    name: 'SLM/DMLS',
    src: Assets.Printing.SLMImage,
    serviceEnum: CapaQuotationDetailedServiceType.SlmDmls,
    url:
      'https://capa.ai/blog/posts/3d-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83'
  },
  {
    id: 7,
    name: '추천이 필요합니다.',
    src: Assets.Printing.Recommend3D,
    serviceEnum: CapaQuotationDetailedServiceType.Recommend,
    url:
      'https://capa.ai/blog/posts/3d-%ED%94%84%EB%A6%B0%ED%8C%85-%EA%B0%9C%EB%85%90-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EC%8B%9C%EC%A0%9C%ED%92%88-%EC%A0%9C%EC%9E%91%EC%9D%98-%EB%AA%A8%EB%93%A0%EA%B2%83'
  }
];
